import { LanguageFlag } from '@app/components/cms/LanguageFlag';
import { PageStatus } from '@app/components/cms/PageStatus';
import { Button } from '@app/components/various/Button';
import { Remove } from '@app/components/various/Icons';
import { useTranslationsConfig } from '@app/utils/hooks';
import { isDefined } from '@app/utils/is';
import { Cms, Translations } from '@typings';

interface Props {
  code: Translations.SupportedLanguagesCodes;
  label: string;
  pageStatus?: Cms.PageStatus;
  onRemove: () => void;
}

export const PageFormLanguagesRow = ({ code, label, pageStatus, onRemove }: Props) => {
  const { getIsDefaultLanguage } = useTranslationsConfig();

  const isDefaultLanguage = getIsDefaultLanguage(code);

  return (
    <div className="grid grid-cols-[120px_auto_min-content] items-center rounded-regular px-3 py-0.5 even:bg-neutral-96">
      <div className="flex items-center gap-2 body-2">
        <LanguageFlag code={code} status={pageStatus} showTooltip={false} /> {label}
      </div>
      {isDefined(pageStatus) && <PageStatus status={pageStatus} />}
      {!isDefaultLanguage && <Button size="medium" color="danger" variant="text" icon={Remove} onClick={onRemove} />}
    </div>
  );
};
